const locationListTypes = [
  {
    label: 'Stores',
    value: 'Supermarket'
  },
  {
    label: 'List of OOH sites',
    value: 'OOH'
  },
  {
    label: 'Other',
    value: 'Other'
  }
]

export default locationListTypes
